import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';

import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Tooltip from '@material-ui/core/Tooltip';
import { lighten } from '@material-ui/core/styles/colorManipulator';

import HOCLoader from '../HOC/HOCLoader.jsx';
import MenuButton from '../Menu/MenuButton';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import { connect } from 'react-redux';
import { compose } from 'redux';
import * as actions from '../../actions';

import { FormattedMessage, injectIntl } from 'react-intl';
import { convertTimestampToDate, SERVER_URL, ROLE_CUSTOMER, countries } from '../../utils/config/constants';
import Axios from 'axios';
import { getCookies } from '../../utils/getToken.js';
import { FlashOffRounded } from '@material-ui/icons';
import Avatar from '@material-ui/core/Avatar';
import { NotificationManager } from 'react-notifications';
import { Button, Fade, Dialog, TextField, Grid, InputLabel, Select, MenuItem, CircularProgress } from '@material-ui/core';
import Dropzone from 'react-dropzone';
import Image from 'react-bootstrap/Image';
import { validateEmployeeForm } from '../../utils/validators/validateForm.js';

const handleDropRejected = (...args) => console.log('reject', args);

function desc(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function stableSort(array, cmp) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = cmp(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map(el => el[0]);
}

function getSorting(order, orderBy) {
    return order === 'desc'
        ? (a, b) => desc(a, b, orderBy)
        : (a, b) => -desc(a, b, orderBy);
}

class EmployeeListHead extends React.Component {
    createSortHandler = property => event => {
        this.props.onRequestSort(event, property);
    };

    render() {
        const rows = [
            {
                id: 'title',
                label: this.props.formatMessage({
                    id: 'employee.image'
                })
            },
            {
                id: 'name',
                label: this.props.formatMessage({
                    id: 'employee.name'
                })
            },
            {
                id: 'email',
                label: this.props.formatMessage({
                    id: 'employee.email'
                })
            },
            {
                id: 'phone',
                label: this.props.formatMessage({
                    id: 'employee.phone'
                })
            },
            {
                id: 'status',
                label: this.props.formatMessage({
                    id: 'employee.status'
                })
            },
            {
                id: 'action',
                label: this.props.formatMessage({
                    id: 'booking.action'
                })
            }
        ];
        const {
            onSelectAllClick,
            order,
            orderBy,
            numSelected,
            rowCount
        } = this.props;

        return (
            <TableHead>
                <TableRow>
                    {/* <TableCell padding="checkbox">
                        <Checkbox
                            indeterminate={
                                numSelected > 0 && numSelected < rowCount
                            }
                            checked={numSelected === rowCount}
                            onChange={onSelectAllClick}
                        />
                    </TableCell> */}
                    {rows.map(
                        row => (
                            <TableCell
                                key={row.id}
                                align={row.numeric ? 'right' : 'left'}
                                padding={
                                    row.disablePadding ? 'none' : 'default'
                                }
                                sortDirection={
                                    orderBy === row.id ? order : false
                                }
                            >
                                <Tooltip
                                    title="Sort"
                                    placement={
                                        row.numeric
                                            ? 'bottom-end'
                                            : 'bottom-start'
                                    }
                                    enterDelay={300}
                                >
                                    <TableSortLabel
                                        active={orderBy === row.id}
                                        direction={order}
                                        onClick={this.createSortHandler(row.id)}
                                    >
                                        {row.label}
                                    </TableSortLabel>
                                </Tooltip>
                            </TableCell>
                        ),
                        this
                    )}
                </TableRow>
            </TableHead>
        );
    }
}

EmployeeListHead.propTypes = {
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.string.isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired
};

const toolbarStyles = theme => ({
    root: {
        paddingRight: theme.spacing.unit
    },
    highlight:
        theme.palette.type === 'light'
            ? {
                color: theme.palette.secondary.main,
                backgroundColor: lighten(theme.palette.secondary.light, 0.85)
            }
            : {
                color: theme.palette.text.primary,
                backgroundColor: theme.palette.secondary.dark
            },
    spacer: {
        flex: '1 1 100%'
    },
    actions: {
        color: theme.palette.secondary.main
    },
    title: {
        flex: '0 0 auto'
    }
});

let EmployeeListToolbar = props => {
    const { numSelected, classes } = props;

    return (
        <div
            className={classNames(classes.root, {
                [classes.highlight]: numSelected > 0
            })}
        >
            {/* <div className={classes.title + ' ds-boar-title' + ' db-list-com'}>
                {numSelected > 0 ? (
                    <Typography color="inherit" variant="subtitle1">
                        {numSelected}{' '}
                        <FormattedMessage
                            id="wallet.selected"
                            defaultMessage="selected"
                        />
                    </Typography>
                ) : (
                        <h2>
                            <FormattedMessage
                                id="employee.heading"
                                defaultMessage="Employees"
                            />
                        </h2>
                    )}
            </div> */}
            <div className={classes.spacer} />
        </div>
    );
};

EmployeeListToolbar.propTypes = {
    classes: PropTypes.object.isRequired,
    numSelected: PropTypes.number.isRequired
};

EmployeeListToolbar = withStyles(toolbarStyles)(EmployeeListToolbar);

const styles = theme => ({
    root: {
        width: '100%',
        marginTop: theme.spacing.unit * 3
    },
    table: {
        minWidth: 700
    },
    tableWrapper: {
        overflowX: 'auto'
    }
});

class EmployeeList extends React.Component {
    constructor(props) {
        super();
        this.state = {
            order: 'asc',
            orderBy: 'name',
            selected: [],
            data: [],
            page: 0,
            rowsPerPage: 10,
            clickValue: '',
            item: {},
            loading: true,
            showEmployeeViewDialog: false,
            addEmployeeDialog: false,
            employeeName: "",//required
            employeeNameError: '',
            employeePhone: "",//required
            employeePhoneError: '',
            employeeEmail: "",//required
            employeeEmailError: '',
            employeeAddress1: "",//required
            employeeAddress1Error: '',
            employeeAddress2: "",
            employeeCity: "",
            employeeCountry: "",//required
            employeeCountryError: '',
            employeeSignature: "",//required
            employeeSignatureError: '',
            employeeCountryCode: "",
            employeeProfilePic: [],
            profilePic: "",
            front_employeeId: [],
            frontID: "",
            back_employeeId: [],
            backID: "",
            is_profile: false,
            is_id_front: false,
            is_id_back: false,
            isAdding: false,
            validationError: ''
        };

        this.handleDrop = this.handleDrop.bind(this);
        this.handleDropBack = this.handleDropBack.bind(this);
        this.handleProfileDrop = this.handleProfileDrop.bind(this);
    }

    handleDelete = async (res) => {
        var authToken = getCookies();
        try {
            const { data } = await Axios({
                method: 'post',
                url: `${SERVER_URL}/provider/remove`,
                data: {
                    id: res.key
                },
                headers: { 'x-auth-token': authToken }
            });
            if (data.status === 'OK') {
                NotificationManager.success(data.message, 'Success')
                this.setState({
                    item: {},
                    clickValue: ''
                }, () => this.getEmployeeData())
            } else {
                NotificationManager.error(data.message, 'Oops!')
                this.setState({
                    item: {},
                    clickValue: ''
                })
            }
            //return validateApiData(data) ? data : errorResponse;
        } catch (e) {
            this.setState({
                data: [],
                loading: false
            })
            //return errorResponse;
        }
    }

    actionCallbacks(action, res) {
        if (action === 'view') {
            var countryItem = {};
            countries.filter(item => item.short === res.country).map(item => {
                countryItem = item;
            })
            this.setState({
                clickValue: 'view',
                item: res,
                showEmployeeViewDialog: true,
                employeeName: res.name,
                employeePhone: res.phone,
                employeeEmail: res.email,
                employeeAddress1: res.address_line_1,
                employeeAddress2: res.address_line_2,
                employeeCity: res.city,
                employeeCountry: countryItem,
                employeeSignature: res.signature,
                employeeCountryCode: res.country_code,
                profilePic: res.proImage.small,
                frontID: res.id_front.small,
                backID: res.id_back.small
            });
        }
        if (action === 'delete') {
            this.handleDelete(res);
        }

    }
    componentDidMount() {
        this.getEmployeeData();
        //this.props.notificationListAction();
    }
    componentDidUpdate(prevProps, prevState) {
        /* if (prevProps.notificationData !== this.props.notificationData) {
            this.setState({ data: this.props.notificationData });
        } */
    }

    getEmployeeData = async () => {
        var authToken = getCookies();
        try {
            const { data } = await Axios({
                method: 'get',
                url: `${SERVER_URL}/provider/employees`,
                headers: { 'x-auth-token': authToken }
            });
            if (data.status === 'OK') {
                this.setState({
                    data: data.data,
                    loading: false
                })
            } else {
                this.setState({
                    data: [],
                    loading: false
                })
            }
            //return validateApiData(data) ? data : errorResponse;
        } catch (e) {
            this.setState({
                data: [],
                loading: false
            })
            //return errorResponse;
        }
    }

    updateEmployeeData = async () => {
        const {
            employeeAddress1,
            employeeSignature,
            employeeCountry,
            employeeName,
            employeeEmail,
            employeePhone
        } = this.state;

        if (
            validateEmployeeForm(
                employeeAddress1,
                employeeSignature,
                employeeCountry,
                employeeName,
                employeeEmail,
                employeePhone,
                this.handleError
            )
        ) {
            this.setState({ isAdding: true })
            var authToken = getCookies();
            var formData = new FormData();
            formData.append("is_profile", this.state.is_profile)
            formData.append("is_id_front", this.state.is_id_front)
            formData.append("is_id_back", this.state.is_id_back)
            formData.append("name", this.state.employeeName)
            formData.append("phone", this.state.employeePhone)
            formData.append("email", this.state.employeeEmail)
            formData.append("country", this.state.employeeCountry.short)
            formData.append("city", this.state.employeeCity)
            formData.append("signature", this.state.employeeSignature)
            formData.append("address_1", this.state.employeeAddress1)
            formData.append("address_2", this.state.employeeAddress2)
            formData.append("id", this.state.item.key)
            if (this.state.is_profile) {
                formData.append('images', this.state.employeeProfilePic[0]);
            }
            if (this.state.is_id_front) {
                formData.append('images', this.state.front_employeeId[0]);
            }
            if (this.state.is_id_back) {
                formData.append('images', this.state.back_employeeId[0]);
            }
            try {
                const { data } = await Axios({
                    method: 'post',
                    url: `${SERVER_URL}/provider/update`,
                    data: formData,
                    headers: { 'x-auth-token': authToken }
                });
                console.log(data)
                if (data.status === 'OK') {
                    NotificationManager.success(data.message, "Success")
                    this.closeDialog();
                    this.getEmployeeData();
                } else {
                    NotificationManager.error(data.message, "Oops!")
                    this.closeDialog();
                }
                //return validateApiData(data) ? data : errorResponse;
            } catch (e) {
                NotificationManager.error("Something went wrong", "Oops!")
                this.closeDialog();
                //return errorResponse;
            }
        } else {
            this.setState({
                validationError: 'Validation error'
            })
        }
    }

    addEmployeeData = async () => {
        const {
            employeeAddress1,
            employeeSignature,
            employeeCountry,
            employeeName,
            employeeEmail,
            employeePhone
        } = this.state;

        if (
            validateEmployeeForm(
                employeeAddress1,
                employeeSignature,
                employeeCountry,
                employeeName,
                employeeEmail,
                employeePhone,
                this.handleError
            )
        ) {
            this.setState({ isAdding: true })

            var authToken = getCookies();
            var formData = new FormData();
            formData.append("is_profile", this.state.is_profile)
            formData.append("is_id_front", this.state.is_id_front)
            formData.append("is_id_back", this.state.is_id_back)
            formData.append("name", this.state.employeeName)
            formData.append("phone", this.state.employeePhone)
            formData.append("email", this.state.employeeEmail)
            formData.append("country", this.state.employeeCountry.short)
            formData.append("city", this.state.employeeCity)
            formData.append("signature", this.state.employeeSignature)
            formData.append("address1", this.state.employeeAddress1)
            formData.append("address2", this.state.employeeAddress2)

            if (this.state.is_profile) {
                formData.append('images', this.state.employeeProfilePic[0]);
            }
            if (this.state.is_id_front) {
                formData.append('images', this.state.front_employeeId[0]);
            }
            if (this.state.is_id_back) {
                formData.append('images', this.state.back_employeeId[0]);
            }
            try {
                const { data } = await Axios({
                    method: 'post',
                    url: `${SERVER_URL}/provider/add`,
                    data: formData,
                    headers: { 'x-auth-token': authToken }
                });
                console.log(data)
                if (data.status === 'OK') {
                    NotificationManager.success(data.message, "Success")
                    this.closeDialog();
                    this.getEmployeeData();
                } else {
                    NotificationManager.error(data.message, "Oops!")
                    this.closeDialog();
                }
                //return validateApiData(data) ? data : errorResponse;
            } catch (e) {
                NotificationManager.error("Something went wrong", "Oops!")
                this.closeDialog();
                //return errorResponse;
            }
        } else {
            this.setState({
                validationError: 'Validation error'
            })
        }
    }

    handleError = params => {
        this.setState(params);
    };

    handleRequestSort = (event, property) => {
        const orderBy = property;
        let order = 'desc';

        if (this.state.orderBy === property && this.state.order === 'desc') {
            order = 'asc';
        }

        this.setState({ order, orderBy });
    };

    handleSelectAllClick = event => {
        if (event.target.checked) {
            this.setState(state => ({ selected: state.data.map(n => n.key) }));
            return;
        }
        this.setState({ selected: [] });
    };

    handleClick = (event, id) => {
        const { selected } = this.state;
        const selectedIndex = selected.indexOf(id);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, id);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1)
            );
        }

        this.setState({ selected: newSelected });
    };

    handleChangePage = (event, page) => {
        this.setState({ page });
    };

    handleChangeRowsPerPage = event => {
        this.setState({ rowsPerPage: event.target.value });
    };

    closeDialog = () => {
        this.setState({
            showEmployeeViewDialog: false,
            addEmployeeDialog: false,
            isAdding: false,
            employeeCountry: "",
            employeeProfilePic: [],
            profilePic: "",
            front_employeeId: [],
            frontID: "",
            back_employeeId: [],
            backID: "",
            employeeNameError: '',
            employeeEmailError: '',
            employeePhoneError: '',
            employeeCountryError: '',
            employeeAddress1Error: '',
            validationError: '',
            employeeSignatureError: ''
        })
    }
    isSelected = id => this.state.selected.indexOf(id) !== -1;


    handleProfileDrop(files) {
        this.setState({
            is_profile: true,
            employeeProfilePic: this.state.employeeProfilePic.concat(files.map(file =>
                Object.assign(file, {
                    preview: URL.createObjectURL(file),
                })))
        })
    }

    handleDrop(files) {
        this.setState({
            is_id_front: true,
            front_employeeId: this.state.front_employeeId.concat(files.map(file =>
                Object.assign(file, {
                    preview: URL.createObjectURL(file),
                })))
        })
    }

    handleDropBack(files) {
        this.setState({
            is_id_back: true,
            back_employeeId: this.state.back_employeeId.concat(files.map(file =>
                Object.assign(file, {
                    preview: URL.createObjectURL(file),
                })))
        })
    }

    handleCountryChange = (event) => {
        console.log("country data", event.target.value)
        this.setState({
            employeeCountry: event.target.value,
            employeeCountryCode: event.target.value.code,
            employeeCountryError: '',
            validationError: ''
        })
    }

    render() {
        const { classes } = this.props;
        const {
            data,
            order,
            orderBy,
            selected,
            rowsPerPage,
            page
        } = this.state;
        const { formatMessage } = this.props.intl;
        const emptyRows =
            rowsPerPage -
            Math.min(rowsPerPage, data.length - page * rowsPerPage);

        //View Redirection
        /* if (this.state.clickValue) {
            if (this.state.item.route == 'BookingDetail') {
                this.props.history.push({
                    pathname:
                        this.state.item.webroute +
                        '/' +
                        this.state.item.notification.payload.additionalData
                            .params.bookingDetail.key,
                    bookingId: this.state.item.notification.payload
                        .additionalData.params.bookingDetail.key
                });
            } else if (this.state.item.route == 'Offers') {
                this.props.history.push({
                    pathname: this.state.item.webroute
                });
            }
        } */
        //View Redirection
        return (
            <HOCLoader loading={this.state.loading}>
                <Paper className={classes.root}>
                    <EmployeeListToolbar numSelected={selected.length} />
                    <div className="mt-1 md-12 mr-1 pt-2 pr-2" style={{ height: 50, justifyContent: "flex-end", display: "flex" }}>
                        <Button variant="contained" color="primary" style={{ width: 120 }} onClick={() => {
                            this.setState({
                                addEmployeeDialog: true,
                                employeeName: "",
                                employeePhone: "",
                                employeeEmail: "",
                                employeeAddress1: "",
                                employeeAddress2: "",
                                employeeCity: "",
                                employeeCountry: "",
                                employeeSignature: "",
                                employeeCountryCode: "",
                                employeeProfilePic: [],
                                profilePic: "",
                                front_employeeId: [],
                                frontID: "",
                                back_employeeId: [],
                                backID: "",
                                is_profile: false,
                                is_id_front: false,
                                is_id_back: false
                            })
                        }}> Add</Button>
                    </div>
                    <div
                        className={
                            classes.tableWrapper + ' db-list-com tz-db-table'
                        }
                    >
                        <Table
                            className={classes.table + ' bordered'}
                            aria-labelledby="tableTitle"
                        >
                            <EmployeeListHead
                                numSelected={selected.length}
                                order={order}
                                orderBy={orderBy}
                                onSelectAllClick={this.handleSelectAllClick}
                                onRequestSort={this.handleRequestSort}
                                rowCount={data.length}
                                formatMessage={this.props.intl.formatMessage}
                            />
                            <TableBody>
                                {stableSort(data, getSorting(order, orderBy))
                                    .slice(
                                        page * rowsPerPage,
                                        page * rowsPerPage + rowsPerPage
                                    )
                                    .map(n => {
                                        const isSelected = this.isSelected(
                                            n.key
                                        );
                                        return (
                                            <TableRow
                                                hover
                                                role="checkbox"
                                                aria-checked={isSelected}
                                                tabIndex={-1}
                                                key={n.key}
                                                selected={isSelected}
                                                style={{
                                                    backgroundColor:
                                                        n.is_read == 2
                                                            ? '#cccccc'
                                                            : 'default'
                                                }}
                                            >
                                                {/* <TableCell padding="checkbox">
                                                    <Checkbox
                                                        onClick={event =>
                                                            this.handleClick(
                                                                event,
                                                                n.key
                                                            )
                                                        }
                                                        checked={isSelected}
                                                    />
                                                </TableCell> */}
                                                <TableCell scope="row">
                                                    <div className="user-profile d-flex flex-row align-items-center">
                                                        <Avatar
                                                            alt={n.name}
                                                            src={
                                                                n.role == ROLE_CUSTOMER
                                                                    ? n.image.small
                                                                    : n.proImage.small
                                                            }
                                                            className="user-avatar"
                                                        />
                                                    </div>
                                                </TableCell>
                                                <TableCell scope="row">
                                                    {
                                                        n.name
                                                    }
                                                </TableCell>
                                                <TableCell scope="row">
                                                    {
                                                        n.email
                                                    }
                                                </TableCell>
                                                <TableCell scope="row">
                                                    {
                                                        n.phone
                                                    }
                                                </TableCell>
                                                <TableCell>
                                                    {
                                                        n.under_review === 1 ? "Verified" : "Not yet verified"
                                                    }

                                                </TableCell>

                                                <TableCell>
                                                    <MenuButton
                                                        rowData={n}
                                                        items={[
                                                            {
                                                                action: 'view',
                                                                label: formatMessage(
                                                                    {
                                                                        id:
                                                                            'booking.view'
                                                                    }
                                                                )
                                                            },
                                                            {
                                                                action: 'delete',
                                                                label: formatMessage(
                                                                    {
                                                                        id:
                                                                            'delete'
                                                                    }
                                                                )
                                                            }
                                                        ]}
                                                        menuId={'bookingMenu'}
                                                        menuCallback={(
                                                            action,
                                                            rowData
                                                        ) =>
                                                            this.actionCallbacks(
                                                                action,
                                                                rowData
                                                            )
                                                        }
                                                        iconType={MoreVertIcon}
                                                    />
                                                </TableCell>
                                            </TableRow>
                                        );
                                    })}
                                {emptyRows > 0 && (
                                    <TableRow
                                        style={{ height: 49 * emptyRows }}
                                    >
                                        <TableCell colSpan={6} />
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>

                        {this.state.showEmployeeViewDialog &&
                            <Dialog
                                TransitionComponent={Fade}
                                disableBackdropClick={true}
                                fullWidth={true}
                                className="service-suggestion-modal md-6 align-self-center"
                                open={this.state.showEmployeeViewDialog}
                                onClose={this.closeDialog}
                                aria-labelledby="form-dialog-title"
                            >
                                <div style={{ backgroundColor: "white" }} className="col p-3 custom-input-text">
                                    <h3>
                                        <FormattedMessage
                                            id="employeeDetails"
                                            defaultMessage="Employee Details"
                                        />
                                    </h3>
                                    <form className="form-new mt-2">
                                        <h4 style={{ marginBottom: 20 }}>
                                            <b>
                                                Profile Picture
                                            </b>
                                        </h4>
                                        <Grid container spacing={2}>
                                            <Grid container xs={12}>
                                                <Grid container spacing={2}>
                                                    <Grid container spacing={2}>
                                                        <Grid key={0} className="row" item>
                                                            <div className="drop-box" style={{ width: 200, height: 100 }}>
                                                                <p>Profile Picture</p>
                                                                <Dropzone
                                                                    onDrop={this.handleProfileDrop}
                                                                    accept="image/jpeg,image/jpg,image/png"
                                                                    multiple={false}
                                                                    maxSize={2097152}
                                                                    onDropRejected={handleDropRejected}
                                                                >
                                                                    {({ getRootProps, getInputProps }) => (
                                                                        <div {...getRootProps()}>
                                                                            <input {...getInputProps()} />
                                                                            <p>
                                                                                <FormattedMessage
                                                                                    id="customer.dropfiles"
                                                                                    defaultMessage="Drop files here, or click to select files"
                                                                                />
                                                                            </p>
                                                                        </div>
                                                                    )}
                                                                </Dropzone>
                                                            </div>
                                                            {this.state.employeeProfilePic.length > 0 ?
                                                                <Paper elevation={3}>
                                                                    <Image src={this.state.employeeProfilePic[0].preview} thumbnail style={{ width: 100, height: 100 }} />
                                                                </Paper> :
                                                                this.state.profilePic === "" ? null :
                                                                    <Paper elevation={3}>
                                                                        <Image src={this.state.profilePic} thumbnail style={{ width: 100, height: 100 }} />
                                                                    </Paper>
                                                            }
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Grid>

                                    </form>
                                    <form className="form-new mt-2">
                                        <TextField
                                            error={this.state.employeeNameError ? true : false}
                                            helperText={this.state.employeeNameError}
                                            className="login-form-textfield"
                                            id="name"
                                            label="Name"

                                            fullWidth={true}
                                            name="name"
                                            placeholder={"Enter Name"}
                                            value={this.state.employeeName}
                                            onChange={event => {
                                                this.setState({
                                                    employeeName: event.target.value,
                                                    employeeNameError: ''
                                                });
                                            }}
                                        />
                                    </form>
                                    <form className="form-new mt-2">
                                        <TextField
                                            error={this.state.employeeEmailError ? true : false}
                                            helperText={this.state.employeeEmailError}
                                            className="login-form-textfield"
                                            id="email"
                                            label="Email"
                                            disabled={true}
                                            fullWidth={true}
                                            name="email"
                                            placeholder={"Enter Email"}
                                            value={this.state.employeeEmail}
                                            onChange={event => {
                                                this.setState({
                                                    employeeEmail: event.target.value,
                                                    employeeEmailError: ''
                                                });
                                            }}
                                        />
                                    </form>
                                    <form className="form-new mt-2">
                                        <TextField
                                            error={this.state.employeePhoneError ? true : false}
                                            helperText={this.state.employeePhoneError}
                                            className="login-form-textfield"
                                            id="phone"
                                            label="Phone"

                                            fullWidth={true}
                                            name="phone"
                                            placeholder={"Enter phone"}
                                            value={this.state.employeePhone}
                                            onChange={event => {
                                                this.setState({
                                                    employeePhone: event.target.value,
                                                    employeePhoneError: ''
                                                });
                                            }}
                                        />
                                    </form>
                                    <form className="form-new mt-2">
                                        <TextField
                                            error={this.state.employeeAddress1Error ? true : false}
                                            helperText={this.state.employeeAddress1Error}
                                            className="login-form-textfield"
                                            id="employeeAddress1"
                                            label="Address 1"

                                            fullWidth={true}
                                            name="employeeAddress1"
                                            placeholder={"Enter Address1"}
                                            value={this.state.employeeAddress1}
                                            onChange={event => {
                                                this.setState({
                                                    employeeAddress1: event.target.value,
                                                    employeeAddress1Error: ''
                                                });
                                            }}
                                        />
                                    </form>
                                    <form className="form-new mt-2">
                                        <TextField
                                            className="login-form-textfield"
                                            id="employeeAddress2"
                                            label="Address 2"

                                            fullWidth={true}
                                            name="employeeAddress2"
                                            placeholder={"Enter Address2"}
                                            value={this.state.employeeAddress2}
                                            onChange={event => {
                                                this.setState({
                                                    employeeAddress2: event.target.value,
                                                });
                                            }}
                                        />
                                    </form>
                                    <form className="form-new mt-2">
                                        <TextField
                                            className="login-form-textfield"
                                            id="employeeCity"
                                            fullWidth={true}
                                            label="City"

                                            name="employeeCity"
                                            placeholder={"Enter City"}
                                            value={this.state.employeeCity}
                                            onChange={event => {
                                                this.setState({
                                                    employeeCity: event.target.value,
                                                });
                                            }}
                                        />
                                    </form>
                                    <div className="col-md-12">
                                        <h6 className="mt-4">Country</h6>
                                        <Select
                                            className="login-form-textfield form-control"
                                            autoWidth={true}
                                            value={this.state.employeeCountry}
                                            onChange={this.handleCountryChange.bind(this)}

                                            inputProps={{
                                                name: 'countryCode'
                                            }}
                                        >
                                            {countries.map((country, index) => {
                                                return (
                                                    <MenuItem
                                                        value={country}
                                                        key={index}
                                                    >
                                                        {country.name}
                                                    </MenuItem>
                                                );
                                            })}
                                        </Select>
                                        <p style={{ color: "red", fontSize: 12, margin: 18 }}>{this.state.employeeCountryError}</p>
                                    </div>

                                    <form className="form-new mt-2">
                                        <TextField
                                            error={this.state.employeeSignatureError ? true : false}
                                            helperText={this.state.employeeSignatureError}
                                            className="login-form-textfield"
                                            id="employeeSignature"
                                            label="Signature"

                                            fullWidth={true}
                                            name="employeeSignature"
                                            placeholder={"Enter Signature"}
                                            value={this.state.employeeSignature}
                                            onChange={event => {
                                                this.setState({
                                                    employeeSignature: event.target.value,
                                                    employeeSignatureError: ''
                                                });
                                            }}
                                        />
                                    </form>


                                    <div className="col-md-12 mt-4">
                                        <h4 style={{ marginBottom: 20 }}>
                                            <b>
                                                Identity Proof
                                            </b>
                                        </h4>
                                        <Grid container spacing={2}>
                                            <Grid container xs={12}>
                                                <Grid container spacing={2}>

                                                    <Grid container spacing={2}>
                                                        <Grid key={0} className="row" item>
                                                            <div className="drop-box" style={{ width: 200, height: 100 }}>
                                                                <p>Identity Front</p>
                                                                <Dropzone
                                                                    onDrop={this.handleDrop}
                                                                    accept="image/jpeg,image/jpg,image/png"
                                                                    multiple={true}
                                                                    maxSize={2097152}
                                                                    onDropRejected={handleDropRejected}
                                                                >
                                                                    {({ getRootProps, getInputProps }) => (
                                                                        <div {...getRootProps()}>
                                                                            <input {...getInputProps()} />
                                                                            <p>
                                                                                <FormattedMessage
                                                                                    id="customer.dropfiles"
                                                                                    defaultMessage="Drop files here, or click to select files"
                                                                                />
                                                                            </p>
                                                                        </div>
                                                                    )}
                                                                </Dropzone>
                                                            </div>
                                                            {this.state.front_employeeId.length > 0 ?
                                                                <Paper elevation={3}>
                                                                    <Image src={this.state.front_employeeId[0].preview} thumbnail style={{ width: 100, height: 100 }} />
                                                                </Paper> :
                                                                this.state.frontID === "" ? null :
                                                                    <Paper elevation={3}>
                                                                        <Image src={this.state.frontID} thumbnail style={{ width: 100, height: 100 }} />
                                                                    </Paper>
                                                            }
                                                        </Grid>
                                                    </Grid>
                                                    <Grid className="mt-2">
                                                        <Grid container spacing={2}>
                                                            <Grid key={0} className="row" item>
                                                                <div className="drop-box" style={{ width: 200, height: 100 }}>
                                                                    <p>Identity Back</p>
                                                                    <Dropzone
                                                                        onDrop={this.handleDropBack}
                                                                        accept="image/jpeg,image/jpg,image/png"
                                                                        multiple={true}
                                                                        maxSize={2097152}
                                                                        onDropRejected={handleDropRejected}
                                                                    >
                                                                        {({ getRootProps, getInputProps }) => (
                                                                            <div {...getRootProps()}>
                                                                                <input {...getInputProps()} />
                                                                                <p>
                                                                                    <FormattedMessage
                                                                                        id="customer.dropfiles"
                                                                                        defaultMessage="Drop files here, or click to select files"
                                                                                    />
                                                                                </p>
                                                                            </div>
                                                                        )}
                                                                    </Dropzone>
                                                                </div>
                                                                {this.state.back_employeeId.length > 0 ?
                                                                    <Paper elevation={3}>
                                                                        <Image src={this.state.back_employeeId[0].preview} thumbnail style={{ width: 100, height: 100 }} />
                                                                    </Paper> :
                                                                    this.state.backID === "" ? null :
                                                                        <Paper elevation={3}>
                                                                            <Image src={this.state.backID} thumbnail style={{ width: 100, height: 100 }} />
                                                                        </Paper>
                                                                }
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        <p style={{ color: "red", fontSize: 12, margin: 18 }}>{this.state.validationError}</p>
                                        <div className="row d-flex" style={{ justifyContent: "space-between" }}>
                                            <button type="button" class="custom-button" style={{ width: "40%" }}
                                                onClick={() => {
                                                    this.updateEmployeeData()
                                                }}>Update</button>
                                            <button type="button" class="custom-button" style={{ width: "40%" }}
                                                onClick={() => {
                                                    this.closeDialog()
                                                }}>Close</button>
                                        </div>
                                    </div>

                                </div>
                            </Dialog>
                        }

                        {this.state.addEmployeeDialog &&
                            <Dialog
                                TransitionComponent={Fade}
                                disableBackdropClick={true}
                                fullWidth={true}
                                className="service-suggestion-modal md-6 align-self-center"
                                open={this.state.addEmployeeDialog}
                                onClose={this.closeDialog}
                                aria-labelledby="form-dialog-title"
                            >

                                <div style={{ backgroundColor: "white" }} className="col p-3 custom-input-text">
                                    <h3>
                                        <FormattedMessage
                                            id="addEmployee"
                                            defaultMessage="Add Employee"
                                        />
                                    </h3>
                                    <form className="form-new mt-2">
                                        <h4 style={{ marginBottom: 20 }}>
                                            <b>
                                                Profile Picture
                                            </b>
                                        </h4>
                                        <Grid container spacing={2}>
                                            <Grid container xs={12}>
                                                <Grid container spacing={2}>
                                                    <Grid container spacing={2}>
                                                        <Grid key={0} className="row" item>
                                                            <div className="drop-box" style={{ width: 200, height: 100 }}>
                                                                <p>Profile Picture</p>
                                                                <Dropzone
                                                                    onDrop={this.handleProfileDrop}
                                                                    accept="image/jpeg,image/jpg,image/png"
                                                                    multiple={false}
                                                                    maxSize={2097152}
                                                                    onDropRejected={handleDropRejected}
                                                                >
                                                                    {({ getRootProps, getInputProps }) => (
                                                                        <div {...getRootProps()}>
                                                                            <input {...getInputProps()} />
                                                                            <p>
                                                                                <FormattedMessage
                                                                                    id="customer.dropfiles"
                                                                                    defaultMessage="Drop files here, or click to select files"
                                                                                />
                                                                            </p>
                                                                        </div>
                                                                    )}
                                                                </Dropzone>
                                                            </div>
                                                            {this.state.employeeProfilePic.length > 0 ?
                                                                <Paper elevation={3}>
                                                                    <Image src={this.state.employeeProfilePic[0].preview} thumbnail style={{ width: 100, height: 100 }} />
                                                                </Paper> :
                                                                this.state.profilePic === "" ? null :
                                                                    <Paper elevation={3}>
                                                                        <Image src={this.state.profilePic} thumbnail style={{ width: 100, height: 100 }} />
                                                                    </Paper>
                                                            }
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Grid>

                                    </form>
                                    <form className="form-new mt-2">
                                        <TextField
                                            error={this.state.employeeNameError ? true : false}
                                            helperText={this.state.employeeNameError}
                                            className="login-form-textfield"
                                            label="Name"
                                            id="name"
                                            fullWidth={true}
                                            name="name"
                                            placeholder={"Enter Name"}
                                            value={this.state.employeeName}
                                            onChange={event => {
                                                this.setState({
                                                    employeeName: event.target.value,
                                                    employeeNameError: '',
                                                    validationError: ''
                                                });
                                            }}
                                        />
                                    </form>
                                    <form className="form-new mt-2">
                                        <TextField
                                            error={this.state.employeeEmailError ? true : false}
                                            helperText={this.state.employeeEmailError}
                                            className="login-form-textfield"

                                            label="Email"

                                            id="email"
                                            fullWidth={true}
                                            name="email"
                                            placeholder={"Enter Email"}
                                            value={this.state.employeeEmail}
                                            onChange={event => {
                                                this.setState({
                                                    employeeEmail: event.target.value,
                                                    employeeEmailError: '',
                                                    validationError: ''
                                                });
                                            }}
                                        />
                                    </form>
                                    <form className="form-new mt-2">
                                        <TextField
                                            error={this.state.employeePhoneError ? true : false}
                                            helperText={this.state.employeePhoneError}
                                            className="login-form-textfield"
                                            id="phone"
                                            label="Phone"

                                            fullWidth={true}
                                            name="phone"
                                            placeholder={"Enter phone"}
                                            value={this.state.employeePhone}
                                            onChange={event => {
                                                this.setState({
                                                    employeePhone: event.target.value,
                                                    employeePhoneError: '',
                                                    validationError: ''
                                                });
                                            }}
                                        />
                                    </form>
                                    <form className="form-new mt-2">
                                        <TextField
                                            error={this.state.employeeAddress1Error ? true : false}
                                            helperText={this.state.employeeAddress1Error}
                                            className="login-form-textfield"
                                            id="employeeAddress1"
                                            label="Address 1"

                                            fullWidth={true}
                                            name="employeeAddress1"
                                            placeholder={"Enter Address1"}
                                            value={this.state.employeeAddress1}
                                            onChange={event => {
                                                this.setState({
                                                    employeeAddress1: event.target.value,
                                                    employeeAddress1Error: '',
                                                    validationError: ''
                                                });
                                            }}
                                        />
                                    </form>
                                    <form className="form-new mt-2">
                                        <TextField
                                            className="login-form-textfield"
                                            id="employeeAddress2"
                                            label="Address 2"

                                            fullWidth={true}
                                            name="employeeAddress2"
                                            placeholder={"Enter Address2"}
                                            value={this.state.employeeAddress2}
                                            onChange={event => {
                                                this.setState({
                                                    employeeAddress2: event.target.value,
                                                });
                                            }}
                                        />
                                    </form>
                                    <form className="form-new mt-2">
                                        <TextField
                                            className="login-form-textfield"
                                            id="employeeCity"
                                            fullWidth={true}
                                            label="City"

                                            name="employeeCity"
                                            placeholder={"Enter City"}
                                            value={this.state.employeeCity}
                                            onChange={event => {
                                                this.setState({
                                                    employeeCity: event.target.value,
                                                });
                                            }}
                                        />
                                    </form>
                                    <div className="col-md-12">
                                        <h6 className="mt-4">Country</h6>
                                        <Select
                                            className="login-form-textfield form-control"
                                            autoWidth={true}
                                            value={this.state.employeeCountry}
                                            onChange={this.handleCountryChange.bind(this)}

                                            inputProps={{
                                                name: 'countryCode'
                                            }}
                                        >
                                            {countries.map((country, index) => {
                                                return (
                                                    <MenuItem
                                                        value={country}
                                                        key={index}
                                                    >
                                                        {country.name}
                                                    </MenuItem>
                                                );
                                            })}
                                        </Select>
                                        <p style={{ color: "red", fontSize: 12, margin: 18 }}>{this.state.employeeCountryError}</p>

                                    </div>

                                    <form className="form-new mt-2">
                                        <TextField
                                            error={this.state.employeeSignatureError ? true : false}
                                            helperText={this.state.employeeSignatureError}
                                            className="login-form-textfield"
                                            id="employeeSignature"
                                            label="Signature"

                                            fullWidth={true}
                                            name="employeeSignature"
                                            placeholder={"Enter Signature"}
                                            value={this.state.employeeSignature}
                                            onChange={event => {
                                                this.setState({
                                                    employeeSignature: event.target.value,
                                                    employeeSignatureError: '',
                                                    validationError: ''
                                                });
                                            }}
                                        />
                                    </form>


                                    <div className="col-md-12 mt-4">
                                        <h4 style={{ marginBottom: 20 }}>
                                            <b>
                                                Identity Proof
                                            </b>
                                        </h4>
                                        <Grid container spacing={2}>
                                            <Grid container xs={12}>
                                                <Grid container spacing={2}>

                                                    <Grid container spacing={2}>
                                                        <Grid key={0} className="row" item>
                                                            <div className="drop-box" style={{ width: 200, height: 100 }}>
                                                                <p>Identity Front</p>
                                                                <Dropzone
                                                                    onDrop={this.handleDrop}
                                                                    accept="image/jpeg,image/jpg,image/png"
                                                                    multiple={false}
                                                                    maxSize={2097152}
                                                                    onDropRejected={handleDropRejected}
                                                                >
                                                                    {({ getRootProps, getInputProps }) => (
                                                                        <div {...getRootProps()}>
                                                                            <input {...getInputProps()} />
                                                                            <p>
                                                                                <FormattedMessage
                                                                                    id="customer.dropfiles"
                                                                                    defaultMessage="Drop files here, or click to select files"
                                                                                />
                                                                            </p>
                                                                        </div>
                                                                    )}
                                                                </Dropzone>
                                                            </div>
                                                            {this.state.front_employeeId.length > 0 ?
                                                                <Paper elevation={3}>
                                                                    <Image src={this.state.front_employeeId[0].preview} thumbnail style={{ width: 100, height: 100 }} />
                                                                </Paper> :
                                                                this.state.frontID === "" ? null :
                                                                    <Paper elevation={3}>
                                                                        <Image src={this.state.frontID} thumbnail style={{ width: 100, height: 100 }} />
                                                                    </Paper>
                                                            }
                                                        </Grid>
                                                    </Grid>
                                                    <Grid className="mt-2">
                                                        <Grid container spacing={2}>
                                                            <Grid key={0} className="row" item>
                                                                <div className="drop-box" style={{ width: 200, height: 100 }}>
                                                                    <p>Identity Back</p>
                                                                    <Dropzone
                                                                        onDrop={this.handleDropBack}
                                                                        accept="image/jpeg,image/jpg,image/png"
                                                                        multiple={false}
                                                                        maxSize={2097152}
                                                                        onDropRejected={handleDropRejected}
                                                                    >
                                                                        {({ getRootProps, getInputProps }) => (
                                                                            <div {...getRootProps()}>
                                                                                <input {...getInputProps()} />
                                                                                <p>
                                                                                    <FormattedMessage
                                                                                        id="customer.dropfiles"
                                                                                        defaultMessage="Drop files here, or click to select files"
                                                                                    />
                                                                                </p>
                                                                            </div>
                                                                        )}
                                                                    </Dropzone>
                                                                </div>
                                                                {this.state.back_employeeId.length > 0 ?
                                                                    <Paper elevation={3}>
                                                                        <Image src={this.state.back_employeeId[0].preview} thumbnail style={{ width: 100, height: 100 }} />
                                                                    </Paper> :
                                                                    this.state.backID === "" ? null :
                                                                        <Paper elevation={3}>
                                                                            <Image src={this.state.backID} thumbnail style={{ width: 100, height: 100 }} />
                                                                        </Paper>
                                                                }
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Grid>

                                        <p style={{ color: "red", fontSize: 12, margin: 18 }}>{this.state.validationError}</p>

                                        <div className="row d-flex" style={{ justifyContent: "space-between" }}>
                                            {this.state.isAdding ? <CircularProgress /> :
                                                <button type="button" class="custom-button" style={{ width: "40%" }}
                                                    onClick={() => {
                                                        this.addEmployeeData()
                                                    }}>ADD</button>
                                            }
                                            <button type="button" class="custom-button" style={{ width: "40%" }}
                                                onClick={() => {
                                                    this.closeDialog()
                                                }}>CLOSE</button>
                                        </div>
                                    </div>

                                </div>


                                {/* <div style={{ backgroundColor: "white" }} className="col p-3">
                                    <h3>
                                        <FormattedMessage
                                            id="addEmployee"
                                            defaultMessage="Add Employee"
                                        />
                                    </h3>
                                    <form className="form-new mt-2">
                                        <TextField
                                            className="login-form-textfield"
                                            id="name"
                                            fullWidth={true}
                                            name="name"
                                            placeholder={"Enter Name"}
                                            value={this.state.employeeName}
                                            onChange={event => {
                                                this.setState({
                                                    employeeName: event.target.value,
                                                });
                                            }}
                                        />
                                    </div>
                                    <form className="form-new mt-2">
                                        <TextField
                                            className="login-form-textfield"
                                            id="email"
                                            fullWidth={true}
                                            name="email"
                                            placeholder={"Enter Email"}
                                            value={this.state.employeeEmail}
                                            onChange={event => {
                                                this.setState({
                                                    employeeEmail: event.target.value,
                                                });
                                            }}
                                        />
                                    </div>
                                    <form className="form-new mt-2">
                                        <TextField
                                            className="login-form-textfield"
                                            id="phone"
                                            fullWidth={true}
                                            name="phone"
                                            placeholder={"Enter phone"}
                                            value={this.state.employeePhone}
                                            onChange={event => {
                                                this.setState({
                                                    employeePhone: event.target.value,
                                                });
                                            }}
                                        />
                                    </div>
                                    <form className="form-new mt-2">
                                        <TextField
                                            className="login-form-textfield"
                                            id="employeeAddress1"
                                            fullWidth={true}
                                            name="employeeAddress1"
                                            placeholder={"Enter Address1"}
                                            value={this.state.employeeAddress1}
                                            onChange={event => {
                                                this.setState({
                                                    employeeAddress1: event.target.value,
                                                });
                                            }}
                                        />
                                    </div>
                                    <form className="form-new mt-2">
                                        <TextField
                                            className="login-form-textfield"
                                            id="employeeAddress2"
                                            fullWidth={true}
                                            name="employeeAddress2"
                                            placeholder={"Enter Address2"}
                                            value={this.state.employeeAddress2}
                                            onChange={event => {
                                                this.setState({
                                                    employeeAddress2: event.target.value,
                                                });
                                            }}
                                        />
                                    </div>
                                    <form className="form-new mt-2">
                                        <TextField
                                            className="login-form-textfield"
                                            id="employeeCity"
                                            fullWidth={true}
                                            name="employeeCity"
                                            placeholder={"Enter City"}
                                            value={this.state.employeeCity}
                                            onChange={event => {
                                                this.setState({
                                                    employeeCity: event.target.value,
                                                });
                                            }}
                                        />
                                    </div>


                                    <div className="col-md-12 mt-4">
                                        <h4 style={{ marginBottom: 20 }}>
                                            <b>
                                                Identity Proof
                                                            </b>
                                        </h4>
                                        <Grid container spacing={2}>
                                            <Grid container xs={12}>
                                                <Grid container spacing={2}>

                                                    <Grid container spacing={2}>
                                                        <Grid key={0} className="row" item>
                                                            <div className="drop-box" style={{ width: 200, height: 100 }}>
                                                                <p>Identity Front</p>
                                                                <Dropzone
                                                                    onDrop={this.handleDrop}
                                                                    accept="image/jpeg,image/jpg,image/png"
                                                                    multiple={true}
                                                                    maxSize={2097152}
                                                                    onDropRejected={handleDropRejected}
                                                                >
                                                                    {({ getRootProps, getInputProps }) => (
                                                                        <div {...getRootProps()}>
                                                                            <input {...getInputProps()} />
                                                                            <p>
                                                                                <FormattedMessage
                                                                                    id="customer.dropfiles"
                                                                                    defaultMessage="Drop files here, or click to select files"
                                                                                />
                                                                            </p>
                                                                        </div>
                                                                    )}
                                                                </Dropzone>
                                                            </div>
                                                            {this.state.front_employeeId.length > 0 &&
                                                                <Paper elevation={3}>
                                                                    <Image src={this.state.front_employeeId[0].preview} thumbnail style={{ width: 100, height: 100 }} />
                                                                </Paper>
                                                            }
                                                        </Grid>
                                                    </Grid>
                                                    <Grid className="mt-2">
                                                        <Grid container spacing={2}>
                                                            <Grid key={0} className="row" item>
                                                                <div className="drop-box" style={{ width: 200, height: 100 }}>
                                                                    <p>Identity Back</p>
                                                                    <Dropzone
                                                                        onDrop={this.handleDropBack}
                                                                        accept="image/jpeg,image/jpg,image/png"
                                                                        multiple={true}
                                                                        maxSize={2097152}
                                                                        onDropRejected={handleDropRejected}
                                                                    >
                                                                        {({ getRootProps, getInputProps }) => (
                                                                            <div {...getRootProps()}>
                                                                                <input {...getInputProps()} />
                                                                                <p>
                                                                                    <FormattedMessage
                                                                                        id="customer.dropfiles"
                                                                                        defaultMessage="Drop files here, or click to select files"
                                                                                    />
                                                                                </p>
                                                                            </div>
                                                                        )}
                                                                    </Dropzone>
                                                                </div>
                                                                {this.state.back_employeeId.length > 0 &&
                                                                    <Paper elevation={3}>
                                                                        <Image src={this.state.back_employeeId[0].preview} thumbnail style={{ width: 100, height: 100 }} />
                                                                    </Paper>
                                                                }
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Grid>

                                        <div className="row">
                                            <button type="button" class="btn btn-primary btn-lg ml-3 mt-3"
                                                onClick={() => {
                                                    
                                }}>Update</button>
                            <button type="button" class="btn btn-primary btn-lg ml-3 mt-3"
                                onClick={() => {
                                    this.closeDialog()
                                }}>Close</button>
                                        </div>
                                    </div>

                                </div>
                */}
                            </Dialog>
                        }
                    </div>
                    <TablePagination
                        className="table-pagination"
                        rowsPerPageOptions={[5, 10, 25]}
                        component="div"
                        count={data.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        backIconButtonProps={{
                            'aria-label': formatMessage({
                                id: 'pagination.previous'
                            })
                        }}
                        nextIconButtonProps={{
                            'aria-label': formatMessage({
                                id: 'pagination.next'
                            })
                        }}
                        onChangePage={this.handleChangePage}
                        onChangeRowsPerPage={this.handleChangeRowsPerPage}
                    />
                </Paper >
            </HOCLoader >
        );
    }
}

EmployeeList.propTypes = {
    classes: PropTypes.object.isRequired
};
const mapStateToProps = ({ notification, auth }) => {
    return {
        notificationData: notification.notificationData,
        notificationLoader: notification.notificationLoader,
        userData: auth.userData
    };
};
const composedComponent = compose(
    withStyles(styles),
    connect(
        mapStateToProps,
        actions
    )
);

export default composedComponent(injectIntl(EmployeeList));


// WEBPACK FOOTER //
// ./src/components/Customer/EmployeeList.jsx